<template>
  <div>

    <template v-if="feedback == null"></template>

    <template v-else>

      <Filters v-bind:params="params"></Filters>

      <template v-if="feedback.length == 0">
        <div class="text-center mt-12">
          <img src="/static/img/icons/icons8-unfriend_male_filled.png" style="width:50px;" />

          <div class="mt-4 text-lg font-thin text-gray-700">
            No feedback found.
          </div>
        </div>
      </template>

      <template v-else>        
        <table class="bp-table">
          <thead>
            <tr class="border-b border-t">
              <th class="py-4 pl-6 pr-4 text-left border-r">
                Date

               <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="date"
                  orderKeyLabel="date"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                User

                <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="user-type"
                  orderKeyLabel="user"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                Broker

                <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="broker-name"
                  orderKeyLabel="broker"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                Client

                <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="client-name"
                  orderKeyLabel="client"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="w-1/2 p-4 text-left border-r">
                Message
              </th>
            </tr>
          </thead>
          <tbody>
            <UserFeedbackListItem
              v-for="(feedbackItem, index) in feedback"
              v-bind:key="index"
              v-bind:feedbackItem="feedbackItem"
              v-bind:index="index">
            </UserFeedbackListItem>
          </tbody>
        </table>

        <div class="p-4 overflow-hidden">
          <div class="float-left mr-12" style="margin-top:5px;">
            Found {{ this.numFeedback }} items of feedback
          </div>

          <template v-if="this.numFeedback > this.params.limit">
            <paginate
              :page-count="Math.ceil(this.numFeedback / this.params.limit)"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="prev"
              :next-text="next"
              :click-handler="paginate">
            </paginate>
          </template>
        </div>

      </template>
    </template>
  </div>
</template>

<script>

  import Paginate             from "vuejs-paginate";
  import Filters              from "@/views/broker/list/Filters"
  import UserFeedbackListItem from "./UserFeedbackListItem";
  import ContentLoader        from "@/shared/components/loaders/ContentLoader";
  import { EventBus }         from '@/shared/event-bus';
  import OrderByArrow         from '@/shared/components/OrderByArrow'


  export default {

    components: {
      Paginate,
      UserFeedbackListItem,
      ContentLoader,
      Filters,
      OrderByArrow
    },

    data() {
      return {
        feedback   : null,
        numFeedback: null,

        prev      : "Prev",
        next      : "Next",

        params : {}
      }
    },

    watch: {
      '$route' : {
        immediate: true,
        handler  : function(to, from) {
          if(Object.keys(to.params).length == 0) {
            this.resetParams()
          }

          else {
            this.setParams(to.params)
          }
          this.getFeedback()
        }
      }
    },

    mounted() {
      EventBus.$on('param-changed', keyValue => {
        this.params[keyValue.key] = keyValue.value
        // reset pagination if the search query has changed
        if (keyValue.key === 'query') {
          this.params['offset'] = 0
        }
        this.$router.push({
          name   : 'feedback-list-search',
          params : this.params
        });
      });

      EventBus.$on('reset-params', () => {
        this.resetParams()
        this.$router.push({
          name   : 'feedback-list-search',
          params : this.params
        });
      });

    },

    methods : {

      setParams(params) {
        // this is when we landed on the page and then clicked on
        // any search params to start a search
        if(params && Object.keys(params).length > 0) {
          this.params = params
        }

        // this is when we land directly on a particular search params
        else if(Object.keys(this.$route.params).length > 0) {
          this.params = this.$route.params
        }
      },

      resetParams() {
        this.params = {
          query     : this.$store.state.emptyQueryIndicator,
          orderBy   : "date",
          orderType : "desc",
          limit     : 50,
          offset    : 0
        }
      },

      getFeedback() {
        this.showLoader('Fetching feedback...')
        this.apiGet(this.params, 'feedback/data', (data) => {
          this.hideLoader()
          this.feedback    = data.feedback
          this.numFeedback = data.total
        })
      },

      // whenever someone clicks on the table header, we will update the ordering
      // of the table
      // But what if we clicked on the same header that we are already ordering by?
      // in that case, we are simply swapping from either ascending to descending or
      // vice versa
      updateOrderBy(orderBy) {
        if(this.params.orderBy == orderBy) {
          this.params.orderType = this.params.orderType == 'asc' ? 'desc' : 'asc'
        } else {
          this.params.orderBy = orderBy
        }

        this.getFeedbackAndUpdateRoute()
      },

      paginate(pageNum) {
        this.params.offset = this.params.limit * (pageNum-1)
        this.getFeedbackAndUpdateRoute()
      },

      // each time the search parameter changes
      // we need to update the params on the store
      // and also update the route to reflect the changes
      // so that whenever user refreshes the URL, they are
      // landed on the same page
      getFeedbackAndUpdateRoute() {
        // and let's refresh the route to reflect the new change
        this.$router.push({
          name   : 'feedback-list-search',
          params : this.params
        });

        // let's re-fetch
        this.getFeedback()
      }

    }
  }
</script>
